import React, { useEffect, useState, useContext } from "react";
import Row from "../Row";
import Column from "../Column";
import jobContext from "src/context/jobContext";
import RotateRow from "../RotateRow";
import { useLocation } from "react-router-dom";

const Table4 = ({ sarparastiMostagin, setSarparastiMostagin, reload }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const jobId = params.get("id");
  const { setGreadingScore } = useContext(jobContext)
  const [data, setData] = useState("")

  const [finallScore, setFinallScore] = useState("")
  useEffect(() => {
    const items = JSON.parse(localStorage?.data)?.[jobId]?.sarparastiMostaghim;
    if (items) {
      setData(items)

      const finallScore = (+items["کارمند یا کارگر"] * 2)
        + (+items["کمک کارشناس"] * 4) + (+items["کارشناس"] * 6) +
        (+items["کارشناس ارشد"] * 8) +
        (+items["سطوح مدیریتی"] * 10)

      const allowedScore = finallScore > 25 ? 25 : finallScore
      setFinallScore(finallScore)
      setSarparastiMostagin(allowedScore)
      setGreadingScore((prev) => ({ ...prev, "sarparastiMostaghim": allowedScore }))
    }
  }, [reload])
  return (
    <div>
      <div className="mt-[95px]">
        <RotateRow>سرپرستی مستقیم</RotateRow>
      </div>
      <div className="mt-[-113px] mb-[110px]">
        <Row type={1}>
          <Column>سطوح</Column>
          <Column>امتیاز هر نفر</Column>
          <Column>تعداد افراد تحت سرپرستی</Column>
          <Column>امتیاز کسب شده</Column>
        </Row>
        <Row>
          <Column>کارمند یا کارگر</Column>
          <Column>2 </Column>
          <Column>{data["کارمند یا کارگر"] ? +data["کارمند یا کارگر"] : 0}</Column>
          <Column>{data["کارمند یا کارگر"] ? +data["کارمند یا کارگر"] * 2 : 0}</Column>
        </Row>
        <Row>
          <Column>کمک کارشناس</Column>
          <Column>4</Column>
          <Column>{data["کمک کارشناس"] ? +data["کمک کارشناس"] : 0}</Column>
          <Column>{data["کمک کارشناس"] ? +data["کمک کارشناس"] * 4 : 0}</Column>
        </Row>
        <Row>
          <Column>کارشناس</Column>
          <Column>6</Column>
          <Column>{data["کارشناس"] ? +data["کارشناس"] : 0}</Column>
          <Column>{data["کارشناس"] ? +data["کارشناس"] * 6 : 0}</Column>
        </Row>
        <Row>
          <Column>کارشناس ارشد</Column>
          <Column>8</Column>
          <Column>{data["کارشناس ارشد"] ? +data["کارشناس ارشد"] : 0}</Column>
          <Column>{data["کارشناس ارشد"] ? +data["کارشناس ارشد"] * 8 : 0}</Column>
        </Row>
        <Row>
          <Column>سطوح مدیریتی</Column>
          <Column>10</Column>
          <Column>{data["سطوح مدیریتی"] ? +data["سطوح مدیریتی"] : 0}</Column>
          <Column>{data["سطوح مدیریتی"] ? +data["سطوح مدیریتی"] * 10 : 0}</Column>
        </Row>
        <Row type={2}>
          <Column size={4} h={1}>
            {" "}
            حداکثر امتیاز عامل : 25
          </Column>
          <Column h={1}>امتیاز مکتسبه :{finallScore}</Column>
          <Column h={1}> امتیاز اعمال شده: {sarparastiMostagin}</Column>
          <Column isActive={true} size={3} h={1}>
            {sarparastiMostagin}
          </Column>
        </Row>
      </div>
    </div>
  );
};

export default Table4;
